module.exports = __webpack_public_path__ + "img/icon-light.12b1314a.png";